import { Checkbox, FormControlLabel } from "@material-ui/core";
import React, { useEffect, useState } from "react";

// Style
import "./CheckboxListOptions.scss";

const CheckboxListOptions = ({ category, filterCategories, setFilterCategories, activeCategory }) => {
  const [optionSearchString, setOptionsSearchString] = useState("");
  const [isSelectAll, setIsSelectAll] = useState(false);

  const handleOptionCheckChange = (checked, optionIndex) => {
    setFilterCategories((categories) => {
      let filterCount = 0;
      categories[activeCategory].options = categories[activeCategory].options.map((option, index) => {
        if (optionIndex === index) {
          if (checked) {
            filterCount += 1;
          }
          return { ...option, isSelectedTemp: checked };
        } else {
          if (option.isSelectedTemp) {
            filterCount += 1;
          }
          return option;
        }
      });
      categories[activeCategory].tempFilterCount = filterCount;

      return [...categories];
    });
  };

  const handleSeletAll = (checked) => {
    setFilterCategories((categories) => {
      categories[activeCategory].options = categories[activeCategory].options.map((option, index) => {
        return { ...option, isSelectedTemp: checked };
      });
      categories[activeCategory].tempFilterCount = checked ? categories[activeCategory].options.length : 0;
      return [...categories];
    });
    setIsSelectAll(checked);
  };

  const isIndeterminate = () =>
    filterCategories[activeCategory].tempFilterCount !== 0 &&
    filterCategories[activeCategory].tempFilterCount !== category.options.length;

  useEffect(() => {
    setIsSelectAll(filterCategories[activeCategory].tempFilterCount === category.options.length);
  }, [activeCategory, filterCategories, category.options.length]);

  const filteredCategories = category.options.filter(({ name }) =>
    name.toLowerCase().includes(optionSearchString.trim().toLowerCase())
  );

  return (
    <div className="chekbox-list-options-container">
      <div className="top">
        <input
          type="text"
          maxLength="300"
          placeholder={`Search ${category.name}`}
          onChange={(e) => setOptionsSearchString(e.target.value)}
          value={optionSearchString}
        />
        <div className="select-all">
          <FormControlLabel
            aria-label="Select All"
            onClick={(event) => event.stopPropagation()}
            onFocus={(event) => event.stopPropagation()}
            control={
              <Checkbox
                checked={isSelectAll}
                onChange={(e) => handleSeletAll(e.target.checked)}
                disableRipple={true}
                className="accordion-checkbox"
                size="small"
                indeterminate={isIndeterminate()}
              />
            }
            label="Select All"
          />
        </div>
      </div>
      <div className="bottom">
        {filteredCategories.length !== 0 ? (
          filteredCategories.map(({ id, isSelected, isSelectedTemp, name }, index) => (
            <div className="checkbox-item" key={id}>
              <FormControlLabel
                aria-label="Select All"
                onClick={(event) => event.stopPropagation()}
                onFocus={(event) => event.stopPropagation()}
                control={
                  <Checkbox
                    checked={isSelectedTemp}
                    onChange={(e) => handleOptionCheckChange(e.target.checked, index)}
                    disableRipple={true}
                    className="accordion-checkbox"
                    size="small"
                  />
                }
                label={name}
              />
            </div>
          ))
        ) : (
          <div className="no-category">No results found!</div>
        )}
      </div>
    </div>
  );
};

export default CheckboxListOptions;
